import React from "react";

const Faq = () => {
  return (
    <>
      <section id="faq" className="startup-locations" style={{ backgroundColor: "#ffffff" }}>
        <div className="container-fluid"></div>
        <div className="container">
          <div className="row ">
            <div className="col-lg-12 mx-auto">
              <h1 className="text-#0081FF  text-center">FAQ</h1>
              <p
                className="h2 text-#0081FF  text-center"
                style={{ fontSize: "25px", marginTop: "10px" }}
              >
                You have Questions ?
              </p>
              <p
                className="text-#0081FF  text-center"
                style={{ fontSize: "20px", marginTop: "10px" }}
              >
                And we have got answers to all of them
              </p>
              <div className="u-h-4 u-w-50 bg-primary rounded mt-4 u-mb-50 mx-auto"></div>

              <div className="accordion " id="faqAccordion">
                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading1"
                    data-toggle="collapse"
                    data-target="#faqCollapse1"
                    aria-expanded="false"
                    aria-controls="faqCollapse1"
                  >
                    <h5 style={{ color: "#fff" }}>
                      What are the available sizes and configurations for office
                      space in Raipur?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse1"
                    className="collapse"
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading1"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      We offer various office space sizes and configurations as
                      per requirement like bare shell, single desk dedicated
                      private office, cabin room, and virtual office space in
                      Raipur.
                    </p>
                  </div>
                </div>
                {/* <!--second--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading2"
                    data-toggle="collapse"
                    data-target="#faqCollapse2"
                    aria-expanded="false"
                    aria-controls="faqCollapse2"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Is there any coworking space available at premisin?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse2"
                    className="collapse"
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading2"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Yes, we offer coworking spaces for rent in Raipur. We
                      offer shared office facilities that foster a collaborative
                      environment.
                    </p>
                  </div>
                </div>

                {/* <!--third--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading3"
                    data-toggle="collapse"
                    data-target="#faqCollapse3"
                    aria-expanded="false"
                    aria-controls="faqCollapse3"
                  >
                    <h5 style={{ color: "#fff" }}>
                      What is the average rental cost for office space?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse3"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading3"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      The average rental cost for office space varies based on
                      size and location.
                    </p>
                  </div>
                </div>
                {/* <!--fourth--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading4"
                    data-toggle="collapse"
                    data-target="#faqCollapse4"
                    aria-expanded="false"
                    aria-controls="faqCollapse4"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Are there any additional costs or fees associated with
                      renting office space?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse4"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading4"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      There is no additional costs or fees associated with
                      renting office space, please inquire for details.
                    </p>
                  </div>
                </div>

                {/* <!--five--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading5"
                    data-toggle="collapse"
                    data-target="#faqCollapse5"
                    aria-expanded="false"
                    aria-controls="faqCollapse5"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Are there flexible lease options available for office
                      spaces?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse5"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading5"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Yes, we offer flexible lease options as per required space
                      from 6 month to 5 years.
                    </p>
                  </div>
                </div>

                {/* <!--six--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading6"
                    data-toggle="collapse"
                    data-target="#faqCollapse6"
                    aria-expanded="false"
                    aria-controls="faqCollapse6"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Is office space located in a prime business location?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse6"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading6"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Our office spaces are situated in 9+ prime location
                      including Vallabh Nagar, Bhatagaon, Kamal Vihar, Lalpur,
                      Pachpedi Naka, Priyadarshini Nagar, Agrasen Chowk, Mowa
                      and more in raipur.
                    </p>
                  </div>
                </div>
                {/* <!--seven-->
      
      <!--            <div className="card my-3"  style ="box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px; max-width : 900px; margin:auto;" >-->
      <!--  <div className="card-header d-flex"  style ="background-color :#0081FF; border-bottom : 0.25px solid #fff " id="faqHeading7"  data-toggle="collapse" data-target="#faqCollapse7" aria-expanded="false" aria-controls="faqCollapse7">-->
            
      <!--    <h5 style={{color : "#fff"}}>-->
      <!--        Is there meeting room facilities available in the office space?-->
            
      <!--    </h5>-->
      <!--    <span className="float-right ml-auto "><i className="fa fa-angle-down" style={{fontSize : "30px" , color : "#fff"}}  aria-hidden="true"></i></span>-->
      <!--  </div>-->

      <!--  <div id="faqCollapse7" className="collapse "  style ="background-color :#0081FF" aria-labelledby="faqHeading7" data-parent="#faqAccordion">-->
      <!--    <p style={{padding : "0 20px", color : "#fff "}} >-->
      <!--     Our office spaces are situated in 9+ prime location including Vallabh Nagar, Bhatagaon, Kamal Vihar, Lalpur, Pachpedi Naka, Priyadarshini Nagar, Agrasen Chowk, Mowa and more in raipur.-->
      <!--    </p>-->
      <!--  </div>-->
      <!--</div>--> */}

                {/* <!--eight--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading8"
                    data-toggle="collapse"
                    data-target="#faqCollapse8"
                    aria-expanded="false"
                    aria-controls="faqCollapse8"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Is there meeting room facilities available in the office
                      space?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse8"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading8"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Yes, we provide meeting room facilities in our office
                      space in Raipur.
                    </p>
                  </div>
                </div>

                {/* <!--nine--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading9"
                    data-toggle="collapse"
                    data-target="#faqCollapse9"
                    aria-expanded="false"
                    aria-controls="faqCollapse9"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Is office spaces equipped with modern amenities?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse9"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading9"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Yes, our office spaces are equipped with modern amenities
                      including air conditioning, internet access, power backup,
                      electricity, housekeeping services, security measures, a
                      club area, pantry facilities, lift access, CCTV
                      surveillance, and parking options.
                    </p>
                  </div>
                </div>

                {/* <!--ten--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading10"
                    data-toggle="collapse"
                    data-target="#faqCollapse10"
                    aria-expanded="false"
                    aria-controls="faqCollapse10"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Is parking available for tenant’s client at the premise?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse10"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading10"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      Parking facilities are provided for tenants and their
                      client at every location of our office space.
                    </p>
                  </div>
                </div>

                {/* <!--eleven--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading11"
                    data-toggle="collapse"
                    data-target="#faqCollapse11"
                    aria-expanded="false"
                    aria-controls="faqCollapse11"
                  >
                    <h5 style={{ color: "#fff" }}>
                      How can I ensure the security of my rented office space?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse11"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading11"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff " }}>
                      We prioritize the security of your office spaces with
                      robust measures like CCTV surveillance, security guard and
                      etc.
                    </p>
                  </div>
                </div>

                {/* <!--twelve--> */}

                <div
                  className="card my-3"
                  style={{ boxShadow: "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px", maxWidth: "900px", margin: "auto" }}
                >
                  <div
                    className="card-header d-flex"
                    style={{ backgroundColor: "#0081FF", borderBottom: "0.25px solid #fff " }}
                    id="faqHeading12"
                    data-toggle="collapse"
                    data-target="#faqCollapse12"
                    aria-expanded="false"
                    aria-controls="faqCollapse12"
                  >
                    <h5 style={{ color: "#fff" }}>
                      Are there nearby restaurants and public transportation
                      options?
                    </h5>
                    <span className="float-right ml-auto ">
                      <i
                        className="fa fa-angle-down"
                        style={{ fontSize: "30px", color: "#fff" }}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>

                  <div
                    id="faqCollapse12"
                    className="collapse "
                    style={{ backgroundColor: "#0081FF" }}
                    aria-labelledby="faqHeading12"
                    data-parent="#faqAccordion"
                  >
                    <p style={{ padding: "0 20px", color: "#fff" }}>
                      Our office spaces are conveniently located near
                      restaurants and public transportation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
